import React, { PureComponent } from 'react';
import ModifierInput from './ModifierInput';
import { uniqueId, toNumber, get } from 'lodash';
import { enforceForceModifierCount } from '../../../../actions/cartActions';

class ModifierInputList extends React.Component {
  static RADIO_TYPE = 'radio';
  static CHECKBOX_TYPE = 'checkbox';
  constructor(props) {
    super(props);
    this.state = {
      userToggled: false,
    };
  }

  handleModifierSelectedChange = modifier => {
    let { modifiers, type, onChange } = this.props;
    this.onChange(modifier);
    onChange && onChange();
  };

  handleModifierChange = currentModifier => {
    if (this.props.onChange) this.props.onChange();
  };

  onChange = currentModifier => {
    this.setState({
      userToggled: true,
    });
    const { modifiers, modifierOptionType, type } = this.props;
    const mStatus = enforceForceModifierCount(modifierOptionType, modifiers);
    if (
      // Enforce option do not exist.
      mStatus.count === -1 ||
      !(
        !currentModifier.selected &&
        mStatus.count > 1 &&
        mStatus.selected >= mStatus.count
      )
    ) {
      if (type === ModifierInputList.RADIO_TYPE) {
        modifiers.forEach(modifier => {
          if (modifier !== currentModifier) modifier.selected = false;
        });
      }
      currentModifier.selected = !currentModifier.selected;
    }
  };
  getType = () => this.props.type;

  render() {
    const { title, type, modifiers, partialServingPricing } = this.props;
    const containerClasses =
      this.props.mobile === true
        ? 'col-md-12 col-xs-12 col-lg-12 col-sm-12 mobile-modifier-container'
        : 'col-lg-12 col-md-6 col-xs-12 col-sm-6';
    const uniqueModifierId = uniqueId('radio');
    const mStatus = enforceForceModifierCount(
      this.props.modifierOptionType,
      this.props.modifiers
    );
    const isValid = mStatus.count === mStatus.selected;

    return (
      <div className={containerClasses}>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 modifierTitle bold">
          {title}
        </div>
        {mStatus.count > 1 && (
          <div className="text-muted mv-1" style={{ fontSize: 10 }}>
            (Choose {mStatus.count})
          </div>
        )}
        <div className="pizzaCreatorModifierSelectList">
          {modifiers.map(modifier => (
            <ModifierInput
              key={modifier.id}
              modifier={modifier}
              type={type}
              name={uniqueModifierId}
              onSelectedChange={this.handleModifierSelectedChange}
              onModifierChange={this.handleModifierChange}
              partialServingPricing={partialServingPricing}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default ModifierInputList;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/ModifierInputList.jsx